module.exports = __webpack_public_path__ + "img/logo1.f812c7c2.png";